window.submitNyeremenyjatek = function (token) {
	document.getElementById('nyeremenyjatekForm').submit();
}




// WEBPACK FOOTER //
// ./resources/js/app.js